// Avisa al servidor la zona horaria del navegador por si el usuario cambió de lugar. Solo con el
// meta CSRF presente: sin él (tests con forgery protection apagada, páginas sin csrf_meta_tags) el
// querySelector devolvía null y el TypeError al evaluar este módulo cortaba el resto del bundle
// (window.toastr, window.moment, Rails.start, ActiveStorage.start nunca corrían).
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

if (csrfToken) {
  fetch("/update_timezone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    },
    body: JSON.stringify({ timezone: timezone })
  }).then(() => {
    // console.log('Zona horaria actualizada en el servidor:', timezone);
  });
}
